import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { base_url } from "Backend/api";
import { useNavigate } from 'react-router-dom';

const CouponsSection = () => {
  const navigate = useNavigate();

  const [coupons, setCoupons] = useState([]);

  const fetchCoupons = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${base_url}/api/coupons?applies_to_type=restaurant&is_active=true`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
          }
        }
      );

      const data = await res.json();

      if (data.status) {
        const formattedCoupons = data.data.map((item) => ({
          id: item.id,
          value: item.discount_value,
          currency: item.discount_type === "percentage" ? "%" : "ل.س",
          title: item.title,
          description: item.description,
          validUntil: new Date(item.ends_at).toLocaleDateString("ar-EG"),
          minimum: item.minimum_order_amount
        }));

        setCoupons(formattedCoupons);
      }

    } catch (error) {
      console.error("Coupons Error:", error);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    coupons.length === 0 ? null : (
    <section id="coupons" className="w-full px-4 md:px-6 lg:px-8 py-1 md:py-4 lg:py-6 scroll-mt-32">
      <div className="max-w-7xl mx-auto">

        <h2 className="text-[14px] md:text-[16px] lg:text-[18px] font-bold text-foreground mb-2  font-[cairo]">
          كوبونات
        </h2>

        <Swiper
          modules={[Navigation]}
          spaceBetween={10}
          slidesPerView={1.7}
          breakpoints={{
            640: { slidesPerView: 1.5, spaceBetween: 10 },
            768: { slidesPerView: 2.5, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 10 }
          }}
          dir="rtl"
        >
          {coupons.map((coupon) => (
            <SwiperSlide key={coupon.id}>
              
              <div
              onClick={() => navigate("/cart")}
              className="coupon-ticket cursor-pointer border rounded-xl p-2 md:p-2 font-[cairo] bg-white">

                <div className="flex items-start justify-between gap-3">

                  <div className="flex-1 min-w-0 ">
                    <div className="flex items-baseline ">
                      <span className="text-lg md:text-xl font-bold text-[#FF4500]">
                        {coupon.value}
                      </span>
                      <span className="text-sm text-[#FF4500]">
                        {coupon.currency}
                      </span>
                    </div>

                    <h3 className="text-[10px] line-clamp-1  md:text-base font-bold text-foreground  font-[cairo]">
                      {coupon.title}
                    </h3>

                    <p className="text-[8px] w-[90%] text-muted-foreground line-clamp-1 font-[cairo]">
                      {coupon.description}
                    </p>
                  </div>

                  <div className="text-[8px] md:text-xs text-muted-foreground mt-3">
                    <div>
                      ينتهى فى : {coupon.validUntil}
                    </div>
                    <div>
                      الحد الأدنى : {coupon.minimum} ل.س
                    </div>
                  </div>

                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
   )
  );
};

export default CouponsSection;